// Copyright (c) 2017-2022 Uber Technologies Inc.
//
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import moment from 'moment';
import { getDatetimeFormattedString } from '@/helpers';

const getTimeElapsedDisplay = ({
  dateFormat,
  event: { timestamp = null },
  eventList,
  index,
  timeFormat,
  timezone,
}) => {
  if (!timestamp || index === -1) {
    return '';
  }

  if (index === 0) {
    return getDatetimeFormattedString({
      date: timestamp,
      dateFormat,
      timeFormat,
      timezone,
    });
  }

  const deltaFromPrev = moment.duration(
    timestamp - eventList[index - 1].timestamp,
  );
  let elapsed = moment.duration(timestamp - eventList[0].timestamp).format();

  if (deltaFromPrev.asSeconds() >= 1) {
    elapsed += ` (+${deltaFromPrev.format()})`;
  }

  return elapsed;
};

export default getTimeElapsedDisplay;
